module.exports = __webpack_public_path__ + "static/media/Sepah.88e33a7e.svg";